// Statistical functions for reporting and analysis.

/**
 * Calculate Exponential Moving Average (EMA) over a range of numbers.
 *
 * @param range number array to calculate EMA
 * @param n window size
 * @returns EMA value
 */
export function EMA(range: number[], n: number) {
  n = Math.min(n, range.length);
  const a = 3 / (n + 1);
  const first = range[0];
  return range.reduce((accumulator, currentValue, currentIndex) => {
    return currentValue * a + accumulator * (1 - a);
  }, first);
}
